import { JSX, useEffect } from "react";
import { useSidebarController } from "../../GlobalData";
import { useElementDepth } from "../../providers/GlobalProviders";
export function DefaultSidebarApplier({ children }: { children: JSX.Element | JSX.Element[] }) {
    const controller = useSidebarController()
    const [ref2, depth] = useElementDepth()

    useEffect(() => {
        return controller.queueSidebar(depth, () => <><DefaultSidebar controller={controller} /></>)
    }, [depth])
    return <div ref={ref2}>
        {children}
    </div>
}

export function DefaultSidebar({ controller }: { controller: ReturnType<typeof useSidebarController> }) {
    return <div className="relative w-max max-w-sm h-full bg-white z-50">
        <div className="p-4">
            {/* Close Button */}
            <button
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                onClick={() => {
                    controller.setSidebarState(false)
                }}
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>

            <h2 className="text-xl font-bold text-[#2B5C56] mt-8 mb-4">Menu</h2>

            {/* Search bar inside sidebar */}
            <div className="flex flex-row items-center border border-[#2B5C56] rounded-full w-full bg-white mb-6">
                <input
                    type="text"
                    placeholder="Cari kursus..."
                    className="flex-1 px-5 py-2 bg-transparent outline-none text-[#2B5C56] rounded-full"
                />
                <button className="bg-[#2B5C56] rounded-full w-8 h-8 flex items-center justify-center mr-2">
                    <svg width="18" height="18" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="8" cy="8" r="7" />
                        <line x1="13" y1="13" x2="17" y2="17" />
                    </svg>
                </button>
            </div>

            {/* Trending Skills */}
            <h3 className="text-lg font-bold text-[#2B5C56] mb-4">Tranding Skill</h3>
            <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="flex items-center p-3 bg-[#EBF5F4] rounded-lg">
                    <span className="font-medium text-[#2B5C56] text-sm">Phyton</span>
                </div>
                <div className="flex items-center p-3 bg-[#EBF5F4] rounded-lg">
                    <span className="font-medium text-[#2B5C56] text-sm">Excel</span>
                </div>
                <div className="flex items-center p-3 bg-[#EBF5F4] rounded-lg">
                    <span className="font-medium text-[#2B5C56] text-sm">Marketing</span>
                </div>
                <div className="flex items-center p-3 bg-[#EBF5F4] rounded-lg">
                    <span className="font-medium text-[#2B5C56] text-sm">Power BI</span>
                </div>
            </div>

            {/* Categories */}
            <h3 className="text-lg font-bold text-[#2B5C56] mb-4">Kategori</h3>
            <div className="space-y-2">
                <a href="#/" onClick={() => {
                    controller.setSidebarState(false)
                }} className="block text-[#2B5C56] hover:text-[#184D47] text-base p-3 rounded hover:bg-[#EBF5F4]">Digital Marketing</a>
                <a href="#/" onClick={() => {
                    controller.setSidebarState(false)
                }} className="block text-[#2B5C56] hover:text-[#184D47] text-base p-3 rounded hover:bg-[#EBF5F4]">Technology & Programming</a>
                <a href="#/" onClick={() => {
                    controller.setSidebarState(false)
                }} className="block text-[#2B5C56] hover:text-[#184D47] text-base p-3 rounded hover:bg-[#EBF5F4]">Business & Management</a>
                <a href="#/" onClick={() => {
                    controller.setSidebarState(false)
                }} className="block text-[#2B5C56] hover:text-[#184D47] text-base p-3 rounded hover:bg-[#EBF5F4]">Design & Creativity</a>
                <a href="#/" onClick={() => {
                    controller.setSidebarState(false)
                }} className="block text-[#2B5C56] hover:text-[#184D47] text-base p-3 rounded hover:bg-[#EBF5F4]">Data & Analytics</a>
                <a href="#/" onClick={() => {
                    controller.setSidebarState(false)
                }} className="block text-[#2B5C56] hover:text-[#184D47] text-base p-3 rounded hover:bg-[#EBF5F4]">Personal Development & Career</a>
                <a href="#/" onClick={() => {
                    controller.setSidebarState(false)
                }} className="block text-[#2B5C56] hover:text-[#184D47] text-base p-3 rounded hover:bg-[#EBF5F4] font-semibold">Semua Kategori</a>
            </div>
        </div>
    </div>
}